import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {AuthenticationService} from './authentication.service';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authenticationSvc: AuthenticationService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    /*console.log('AuthGuard#canActivate called', this.authenticationSvc);
    console.log('AuthGuard#canActivate called', this.authenticationSvc.currentUserValue);
    console.log('AuthGuard#canActivate called', Object.keys(this.authenticationSvc.currentUserValue).length);*/
    if (Object.keys(this.authenticationSvc.currentUserValue).length > 0) {
      return true;
    } else {
      //console.log('Log out', state.url);
      this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
      return false;
    }
  }
}